import React from 'react'
import { connect } from 'react-redux'
import { push, goBack } from 'react-router-redux'
import Card, { TitleCard } from '../../core/Card'
import Line from '../../core/Line'
import { ForwardIcon, Icon, PlusIcon } from '../../core/icons'
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import { Slider, Select, Button, Col, Row } from 'antd';
import './Vehicles.css'
import New from './New'
import Update from './Update'
import All from './All'
import { listVehicles } from './actions'
import onMount from '../../core/onMount'
import {getVehiclesSorted} from './reducer'

const mapDispatchToProps = (dispatch) => {
  return {
    onClick: (token_id)=> dispatch(push(`/account/vehicles/${token_id}`)),
    dispatch
  }
}

const mapStateToProps = (state) => {
  return {
    vehicles: getVehiclesSorted(state),
  }
}


const ConnectedUpdate = connect(mapStateToProps, mapDispatchToProps)(Update)

// Vehicles were loading twice, once when user success returns and one when list vehicles returns
// const MountedAll = onMount(({dispatch}) => dispatch(listVehicles()) )(All)
// const ConnectedAll = connect(mapStateToProps, mapDispatchToProps)(MountedAll)

const ConnectedAll = connect(mapStateToProps, mapDispatchToProps)(All)


export default (props)=>
  <Switch>
    <Route exact path={`/account/vehicles`} component={ConnectedAll}/>
    <Route path={`/account/vehicles/new`} component={New}/>
    <Route path={`/account/vehicles/:vehicleId`} component={ConnectedUpdate}/>
  </Switch>



// WEBPACK FOOTER //
// ./src/account/vehicles/Vehicles.jsx